export default "__VITE_ASSET__DrzrIXbw__"